export const actionType = {
  CLEAR_API_ALL: 'CLEAR_API_ALL',
  CLEAR_API_ERRORS: 'CLEAR_API_ERRORS',
  CLEAR_API_SUCCESS: 'CLEAR_API_SUCCESS',
};
